import React from 'react'
import { Link } from 'react-router-dom'
import { CButton } from '@coreui/react-pro'

const HelpExternal = (): JSX.Element => {
  return (
    <>
      <Link to="/login">
        <CButton color="primary" className="mt-3" active tabIndex={-1}>
          WebAUSPEX Login Page
        </CButton>
      </Link>
      {
        // eslint-disable-next-line jsx-a11y/iframe-has-title
      }
      <iframe
        src="https://lassip-utfpr.github.io/webauspex/docs/"
        title="Documentation"
        style={{ width: '100%', height: '90vh' }}
      ></iframe>
    </>
  )
}

export default HelpExternal
